import styled from 'styled-components';
import ImpText from '../ImpText/ImpText';
import { colors } from '../../DesignSystem/colors';
import React from 'react';
import ImpFlex from '../../Atoms/ImpFlex/ImpFlex';
const Option = styled.div `
  cursor: pointer;
  background: ${(props) => (props.isFocused ? '#eee' : 'none')};
  white-space: pre-wrap;

  display: flex;
  direction: column;
  align-items: center;
  padding: 12px;
`;
export default function ImpSelectItem({ option, itemRef, isFocused = false, onMouseEnter, handleOptionClick, }) {
    return (React.createElement(Option, { key: option.value, onClick: handleOptionClick, ref: itemRef, isFocused: isFocused, onMouseEnter: onMouseEnter, "data-testid": "option-container" },
        React.createElement(ImpFlex, { direction: "column", gap: "xs" },
            React.createElement(ImpText, { typography: "body2", color: colors.content.onBackground }, option.label),
            option.labelSubtitle && (React.createElement(ImpText, { typography: "body3", color: colors.content.onBackgroundVariant }, option.labelSubtitle)))));
}
//# sourceMappingURL=ImpSelectItem.js.map